import { render, staticRenderFns } from "./IconPlayStore.vue?vue&type=template&id=7270f1b2"
import script from "./IconPlayStore.vue?vue&type=script&lang=js"
export * from "./IconPlayStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports